import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DentistService {
  constructor() { }
  dentistListdata: any
  loanInfo: any
  userCoords
}
